'use client';

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * Sendpulse snippet
 *
 * @returns {React.JSX.Element} The Sendpulse snippet.
 */
export const Sendpulse = ({ id }: { id?: string }) => {
  const sendpulseId = process.env.NEXT_PUBLIC_SENDPULSE_ID;
  const [started, setStarted] = useState(false);
  const [targetHeight, setTargetHeight] = useState(0);
  /* c8 ignore start */
  function handleWindowSizeChange() {
    const element = document.getElementsByClassName('sp-inline-popup')[0];
    if (element) {
      setTargetHeight(element.clientHeight);
    }
  }
  useEffect(() => {
    if (!sendpulseId) {
      console.warn('Missing sendpulseId ID, skipping banner');
      return;
    }
    // Loads like next/script's lazyOnload: once the page has loaded and the main thread is idle, so the widget's
    // script doesn't compete with the page's own JS for the first paint and the first taps
    let idleId: number | undefined;
    const start = () => {
      idleId = window.requestIdleCallback
        ? window.requestIdleCallback(() => setStarted(true), { timeout: 3000 })
        : window.setTimeout(() => setStarted(true), 1);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
    window.addEventListener('resize', handleWindowSizeChange);
    const interval = setInterval(async () => {
      const a = document.getElementsByClassName('sp-inline-popup');
      const spStyle = document.createElement('style');
      spStyle.innerHTML = `
        .sp-popup-wrapper {
          width:100% !important;
        }
      `;
      if (a.length > 0) {
        a[0]?.shadowRoot?.appendChild(spStyle);
        setTargetHeight(a[0]?.clientHeight || 0);
        clearInterval(interval);
      }
    }, 500);
    return () => {
      clearInterval(interval);
      window.removeEventListener('load', start);
      if (idleId !== undefined) {
        if (window.cancelIdleCallback) window.cancelIdleCallback(idleId);
        else window.clearTimeout(idleId);
      }
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  /* c8 ignore end */
  if (!sendpulseId) return <></>;
  return (
    <Box
      sx={{ height: `${targetHeight}px`, opacity: targetHeight > 0 ? '100' : '0', transition: 'all 0.3s ease-in-out' }}
    >
      <div id={`send_pulse${id ? `_${id}` : ''}`} />
      {started && (
        <>
          <script async src="https://static.sppopups.com/assets/loader.js" data-chats-widget-id={sendpulseId} />
        </>
      )}
    </Box>
  );
};

export default Sendpulse;
